/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from '../../../components/Common/Modal';
import * as RT from '../../../constants/Routing';
import * as CONST from '../../../constants/Const';
import * as Actions from '../../../actions/Task';
import Template from '../../../components/Template/AfterLoginTemplate';
import TaskCardForDetail from '../../../components/Parts/TaskCardForDetail';
import ParticipantCard from '../../../components/Parts/ParticipantCard';
import { Link } from 'react-router-dom';
import ApplicantModal from '../../../components/Common/ApplicantModal';
var Highlight = require('react-highlighter');

function CancelUserList(params) {
  console.log('TCL: CancelUserList -> cancelUsers', params.cancelUsers);
  return (
    <div className="applicant-info">
      <div className="title-panel">
        <h2>{params.title}</h2>
      </div>
      {(() => {
        return params.cancelUsers.map(user => {
          return (
            <div className="applicant-info-inner">
              <ParticipantCard
                participant={user}
                enterpriseId={params.currentUser.enterpriseId}
                token={params.currentUser.accessToken}
                taskId={params.task_id}
                key={user.taskrewId}
                noBtn
              />
            </div>
          );
        });
      })()}
    </div>
  );
}

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      modalOpen: false,
      modalType: '',
      modalTitle: '',
      selectedParticipantId: '',
      participant: this.props.Task.taskDetail.participant || [],
      currentTask: true,
      cancelMessageReceived: '0',
      questionValid: false,
      openApplicantModal: false,
      user: {},
      task: {}
    };
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps = next => {
    console.log('TCL: Component -> next', next);

    if (!this.state.loaded && next.Task.taskDetailLoaded !== this.state.loaded) {
      const currentTask = next.Task.taskDetail.taskStatus === 'currentTask';
      this.setState({ loaded: true, currentTask });
    }

    if (next.Task.taskDeleted) {
      this.props.history.push(RT.TASK_INDEX_PATH);
    }

    // 応募承認後
    if (!this.props.Task.approvedTask && next.Task.approvedTask) {
      this.setState({
        modalType: 'taskApproved',
        modalTitle: '応募を承認しました！'
      });
    }

    // 施設からのキャンセル後
    if (!this.props.Task.canceledFromEnterprise && next.Task.canceledFromEnterprise) {
      this.setState({
        modalType: 'taskCanceledFromEnterprise',
        modalTitle: '応募の承認をキャンセルしました'
      });
    }

    // 応募者からのキャンセル承認後
    if (!this.props.Task.canceledFromUser && next.Task.canceledFromUser) {
      this.setState({
        modalOpen: true,
        modalType: 'taskCanceledFromUser',
        modalTitle: 'キャンセルを確認しました'
      });
    }

    // レビュー後
    if (!this.props.Task.reviewSent && next.Task.reviewSent) {
      // console.log('レビューしました！', this.props.Task, next.Task)
      this.setState({
        modalOpen: true,
        modalType: 'reviewSent',
        modalTitle: 'レビューしました',
        reviewPage: false
      });
    }
  };

  componentWillMount = () => {
    this._loadTaskDetail();
  };

  _loadTaskDetail = () => {
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;
    this.props.getTaskDetail(enterpriseId, token, taskId);
  };

  componentWillUnmount = () => {
    this.props.resetTaskDetail();
    this.props.resetEntryApprovalSave();
    this.props.resetCancelApprovalSave();
    this.props.resetCancelRequestApproval();
  };

  _setValue = e => {
    if (e.target.name.match('question') !== null) {
      let questionValid = true;

      if (!e.target.value) {
        questionValid = false;
      }

      this.setState({ [e.target.name]: e.target.value, questionValid }, () => {
        this._checkAllEnter();
      });
    } else if (e.target.name === 'cancelMessageReceived') {
      this.setState({ [e.target.name]: e.target.value });
    } else {
      this.setState({ [e.target.name]: e.target.value }, () => {
        this._checkAllEnter();
      });
      // this.setState({ [e.target.name]: e.target.value })
    }
  };

  _checkAllEnter = () => {
    let questionValid = true;
    Object.entries(this.state.selectedUser.reviewQuestion).map(array => {
      if (!this.state[array[0]]) {
        questionValid = false;
      }
      return true;
    });
    this.setState({ questionValid });
  };

  deleteConfirm = () => {
    this.setState({
      modalOpen: true,
      modalType: 'delete',
      modalTitle: 'このタスクを削除しますか？'
    });
  };

  modalClose = () => {
    this.setState({ modalOpen: false, modalType:"" });
  };

  deleteTask = () => {
    this.setState({
      modalOpen: false
    });
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;
    this.props.taskDeleteAction(enterpriseId, token, taskId);
  };

  entryApprovalConfirm = selectedParticipantId => {
    this.setState({
      modalOpen: true,
      modalType: 'approveTask',
      selectedParticipantId,
      modalTitle: 'このタスクルーの応募を承認しますか？'
    });
  };

  showResume = participant => {
    if (participant) {
      this.props.setParticipantDetail(participant);
      this.props.history.push(
        RT.RESUME_PARTICIPANT_PATH.replace(/:taskrews_id/, participant.taskrewId),
        participant
      );
    } else {
      this.props.history.push();
    }
  };

  showContractPDF = participant => {
    // pass taskid and b user id, and c user id
    if (participant) {
      this.props.setParticipantDetail(participant);
      const taskId = this.props.match.params.task_id;
      const participantid = participant.taskrewId;
      // this.props.setParticipantDetail(participant);
      this.props.history.push(
        RT.CONTRACT_PDF_PATH.replace(/:taskrews_id/, participantid).replace(/:taskid/, taskId)
      );
    }
  };

  entryApproval = () => {
    // 応募承認関数を呼ぶ
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;
    this.props.entryApproval(enterpriseId, token, taskId, this.state.selectedParticipantId);
  };

  cancelApplyFromEnterpriseConfirm = selectedParticipantId => {
    this.setState({
      modalOpen: true,
      modalType: 'cancelTaskFromEnterprise',
      selectedParticipantId,
      modalTitle: '応募の承認をキャンセルしますか？'
    });
  };

  cancelApplyFromEnterprise = () => {
    // 応募承認関数を呼ぶ
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;
    this.props.cancelApproval(enterpriseId, token, taskId, this.state.selectedParticipantId);
  };

  cancelRequestAppry = selectedParticipantId => {
    // 応募承認関数を呼ぶ
    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;
    this.props.cancelRequestApproval(
      enterpriseId,
      token,
      taskId,
      selectedParticipantId,
      this.state.cancelMessageReceived
    );
  };

  modalContent = (allEntryCount = 1) => {
    const task = this.props.Task.taskDetail;
    let content = <div />;
    let user;
    switch (this.state.modalType) {
      case 'delete':
        content = (
          <div className="task-delete-modal">
            <TaskCardForDetail task={task} allEntryCount={allEntryCount} />
            {(task.taskStatusId === CONST.TS_APPROVED || allEntryCount > 0) && (
              <div className="delete-description">
                <h3>
                  <i class="fas fa-exclamation-triangle"></i>
                  <span>ご注意ください！</span>
                </h3>
                <p>
                  このタスクには既に応募者がいらっしゃいます。
                  タスクを削除すると応募済みのタスクルーに通知が送られますが、働くことを楽しみにしているタスクルーの為に直接連絡することをお勧めします。
                </p>
              </div>
            )}
            <div className="task-delete-button text-center">
              <button onClick={this.modalClose} className="btn btn-cancel">
                いいえ
              </button>
              <button onClick={this.deleteTask} className="btn btn-primary">
                はい
              </button>
            </div>
          </div>
        );
        break;

      case 'approveTask':
        const approvedUsers = task.approvalTask === null ? [] : task.approvalTask.filter(Boolean);
        // console.log('approvedTask', this.state.selectedParticipantId, approvedUsers)
        user = approvedUsers.filter((x, i, self) => {
          return x.taskrewId === this.state.selectedParticipantId;
        })[0];
        // console.log('searchResult', user)
        content = (
          <div className="hire-app-block">
            <ParticipantCard
              participant={user}
              enterpriseId={this.currentUser.enterpriseId}
              token={this.currentUser.accessToken}
              taskId={this.props.match.params.task_id}
              key={user.taskrewId}
              modalOpen={this.state.participantModalOpen === user.taskrewId}
            />
            <div className="text-center hire-app-button">
              <button onClick={this.modalClose} className="btn btn-cancel">
                戻る
              </button>
              <button onClick={this.entryApproval} className="btn btn-primary">
                はい
              </button>
            </div>
          </div>
        );
        break;
      case 'taskApproved':
        content = (
          <div className="text-center task-approved">
            <h3>
              このタスクルーを採用しました！連絡をとってタスクの詳細を説明してください。
              <span>他に応募者がいる場合は不採用の連絡をしてください。</span>
            </h3>
            <button
              onClick={() => this.setState({ modalOpen: false }, this._loadTaskDetail())}
              className="btn btn-primary"
            >
              閉じる
            </button>
          </div>
        );
        break;
      case 'cancelTaskFromEnterprise':
        const activeUsers = task.completedTask === null ? [] : task.completedTask.filter(Boolean);
        // console.log('approvedTask', this.state.selectedParticipantId, approvedUsers)
        user = activeUsers.filter(x => {
          return x.taskrewId === this.state.selectedParticipantId;
        })[0];
        // console.log('searchResult', user)
        content = (
          <div className="cancel-applicant">
            <ParticipantCard
              participant={user}
              enterpriseId={this.currentUser.enterpriseId}
              token={this.currentUser.accessToken}
              taskId={this.props.match.params.task_id}
              key={user.taskrewId}
              modalOpen={this.state.participantModalOpen === user.taskrewId}
            />
            <p className="confirm-alert">
              ※一度承認を取消しすると元に戻せません
              <span>
                働くことを楽しみに待っているタスクルーの為に承認を取消しした旨を連絡し、経緯を説明することをお勧めします。
              </span>
            </p>
            <div className="text-center cancel-applicant-button">
              <button onClick={this.modalClose} className="btn btn-cancel">
                戻る
              </button>
              <button onClick={this.cancelApplyFromEnterprise} className="btn btn-primary">
                キャンセルする
              </button>
            </div>
          </div>
        );
        break;
      case 'taskCanceledFromEnterprise':
        content = (
          <div className="text-center">
            <p className="confirm-alert">新しいタスクルーを探しましょう</p>
            <button
              onClick={() => this.setState({ modalOpen: false }, this._loadTaskDetail())}
              className="btn btn-primary"
            >
              閉じる
            </button>
          </div>
        );
        break;
      case 'taskCanceledFromUser':
        content = (
          <div className="mt-5">
            <button
              onClick={() => this.setState({ modalOpen: false }, this._loadTaskDetail())}
              className="btn btn-primary"
            >
              閉じる
            </button>
          </div>
        );
        break;
      case 'reviewConfirm':
        // console.log('reviewConfirm', this.state, Object.entries(this.state.questions))
        user = this.state.selectedUser;
        const questionsList = user.reviewQuestion;

        // console.log('れびゅー', questionsList, this.state, user)
        content = (
          <div className="mt-5">
            <table className="table table-borderless text-left">
              <tbody>
                {() => {
                  return Object.entries(questionsList).map(question => {
                    const answerValue = this.state.questions.question.filter(x => {
                      return x.key === question[1].title;
                    })[0];

                    // let answer = questionMaster.option.filter((x) => {
                    //   return (Number(x.key) === Number(answerValue))
                    // })[0]

                    // console.log('おぶじぇ', this.state, question, answerValue)
                    return (
                      <tr>
                        <th>{question[1].title}</th>
                        <td style={{ textAlign: 'right' }}>
                          <span className="review-value">{answerValue.value}</span> / 5
                        </td>
                      </tr>
                    );
                  });
                }}
              </tbody>
            </table>
            <div className="review-confirm-button">
              <button onClick={this.modalClose} className="btn btn-cancel">
                修正する
              </button>
              <button onClick={this.sendReview} className="btn btn-primary">
                レビューを確定
              </button>
            </div>
          </div>
        );
        break;
      case 'reviewSent':
        content = (
          <div className="reviewed-button">
            <button
              onClick={() =>
                this.setState({ modalOpen: false, reviewPage: false }, this._loadTaskDetail())
              }
              className="btn btn-primary"
            >
              閉じる
            </button>
          </div>
        );
        break;
      default:
        break;
    }
    return content;
  };

  closeModalAction = () => {
    // const task = this.props.Task.taskDetail
    let action = () => { };
    switch (this.state.modalType) {
      case 'delete':
      case 'approveTask':
      case 'cancelTaskFromEnterprise':
      case 'reviewConfirm':
        action = () => {
          this.setState({ modalOpen: false });
        };
        break;
      case 'taskApproved':
      case 'taskCanceledFromEnterprise':
      case 'taskCanceledFromUser':
        action = () => {
          this.setState({ modalOpen: false }, () => {
            this._loadTaskDetail();
          });
        };
        break;
      case 'reviewSent':
        action = () => {
          this.setState({ modalOpen: false, reviewPage: false }, () => {
            this._loadTaskDetail();
          });
        };
        break;
      default:
        break;
    }
    return action;
  };

  _toReview = selectedUser => {
    this.setState({ reviewPage: 'createReview', selectedUser });
  };

  _toViewReview = selectedUser => {
    this.setState({ reviewPage: 'reviewedView', selectedUser });
  };

  _toBack = () => {
    this.setState({ reviewPage: false, selectedUser: null });
  };

  sendReviewConfirm = () => {
    const questions = this.generateReviewObj();
    this.setState({
      modalOpen: true,
      modalType: 'reviewConfirm',
      modalTitle: '以下の内容でレビューを登録します。よろしいですか？',
      questions
    });
  };

  generateReviewObj = () => {
    const object = {};
    const questions = [];
    // let questions = {}

    Object.entries(this.state.selectedUser.reviewQuestion).map(array => {
      // if (!this.state[array[0]]) {
      //   questionValid = false
      // }
      const hash = {};
      hash.key = array[1].title;
      hash.value = this.state[array[0]];
      // questions.push()

      // console.log('generateReviewObj', array)
      // questions[array[0]] = this.state[array[0]]
      questions.push(hash);
      return true;
    });

    object.question = questions;

    // questions.free = this.state.free
    object.free = this.state.free;

    return object;
  };

  sendReview = () => {
    // let questions = {}

    // Object.entries(this.state.selectedUser.reviewQuestion).map((array) => {
    //   // if (!this.state[array[0]]) {
    //   //   questionValid = false
    //   // }
    //   questions[array[0]] = this.state[array[0]]
    // })

    // questions.free = this.state.free

    const questions = this.generateReviewObj();

    const token = this.currentUser.accessToken;
    const { enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;

    this.props.taskReview(
      enterpriseId,
      token,
      taskId,
      this.state.selectedUser.taskrewId,
      questions
    );
  };

  _renderOldReview = (task, allEntryCount) => {
    const user = this.state.selectedUser;
    return (
      <div className="review-wrap">
        <TaskCardForDetail task={task} allEntryCount={allEntryCount} />
        <ParticipantCard
          participant={user}
          enterpriseId={this.currentUser.enterpriseId}
          token={this.currentUser.accessToken}
          taskId={this.props.match.params.task_id}
          key={user.taskrewId}
          noBtn={false}
          oldReview={this.state.reviewPage === 'reviewedView'}
        >
          <button
            onClick={() => this._toBack()}
            className="btn btn-cancel btn-xs"
            style={{
              backgroundColor: '#ffba00'
            }}
          >
            戻る
          </button>
        </ParticipantCard>
      </div>
    );
  };

  _renderReview = (task, allEntryCount) => {
    const user = this.state.selectedUser;

    return (
      <div className="review-wrap">
        <TaskCardForDetail task={task} allEntryCount={allEntryCount} />
        <ParticipantCard
          participant={user}
          enterpriseId={this.currentUser.enterpriseId}
          token={this.currentUser.accessToken}
          taskId={this.props.match.params.task_id}
          key={user.taskrewId}
          noBtn={false}
        >
          <button onClick={() => this._toBack()} className="btn btn-cancel btn-xs">
            戻る
          </button>
        </ParticipantCard>
        <div className="reviewTable">
          <h2>{user.lastName + user.fastName}</h2>
          <p>タスクルーのレビューを完了させてください</p>
          <div className="reviewTable-inner">
            {(() => {
              return (
                user.reviewQuestion !== undefined &&
                Object.entries(user.reviewQuestion).map(question => {
                  return (
                    <div className="reviewTable-common" key={question[0]}>
                      <div className="question-title">{question[1].title}</div>
                      <div className="question-select">
                        <select
                          className="form-select"
                          name={question[0]}
                          id=""
                          onChange={this._setValue}
                          defaultValue=""
                        >
                          <option value="">評価を選択</option>
                          {(() => {
                            return question[1].option.map(item => {
                              return (
                                <option value={item.key} key={item.key}>
                                  {item.value}
                                </option>
                              );
                            });
                          })()}
                        </select>
                      </div>
                    </div>
                  );
                })
              );
            })()}
            <div className="reviewTable-common textarea">
              <div className="question-title">自由に評価をご記入ください</div>
              <textarea
                type="text"
                className="form-control"
                name="free"
                onChange={this._setValue}
                value={this.state.free}
              />
            </div>
          </div>
          <div className="reviewTable-button">
            <button
              onClick={() => this.sendReviewConfirm()}
              className={`btn${this.state.questionValid ? '' : ' disabled'}`}
              disabled={!this.state.questionValid}
            >
              提出
            </button>
          </div>
        </div>
      </div>
    );
  };

  _renderTaskItems = (data, task) => {
    const items = data;
    if (items !== null && items.constructor === Array && items.length > 0) {
      return items.map(item => {
        const cancelText = item.cancelByC ? '応募取消済' : item.cancelByB ? '承認取消' : '';
        return (
          <tr>
            <td>
              <Link onClick={() => this.openApplicantModal(item, task)}>
                {item.lastName}
                {item.fastName} {'('} {Math.round(item.finalAverageOfReviewCount * 10) / 10}
                {'/'}
                {'過去'}
                {item.experiencesCount}
                {'件'} {')'}{' '}
              </Link>
              {cancelText.length > 0 && (
                <Highlight
                  search={cancelText}
                  matchStyle={{ color: '#FFFFFF', backgroundColor: '#707070' }}
                >
                  {cancelText}
                </Highlight>
              )}
            </td>
            <td>{item.sex}</td>
            <td>{item.age}</td>
            <td>
              {item.licenseDetail.length > 0
                ? Array.prototype.map
                  .call(item.licenseDetail, function (item) {
                    return item.value;
                  })
                  .join(', ')
                : 'なし'}
            </td>
            <td>
              {item.taskCancelCount}
              {'回'}
            </td>
            <td>
              {(() => {
                const taskEndDateTime = new Date(`${task.endDate} ${task.endTime}`);
                if (task.taskStatusDetail.key === CONST.TS_CREATE) {
                  return (
                    <div className="export-accept-block">
                      <div className="export-accept-common">
                        <button onClick={() => this.showResume(item)} className="btn btn-primary">
                          履歴書を出力する
                        </button>
                      </div>
                      {taskEndDateTime > new Date() && (
                        <div className="export-accept-common">
                          <button
                            onClick={() => this.entryApprovalConfirm(item.taskrewId)}
                            className="btn btn-primary"
                          >
                            応募を承認する
                          </button>
                        </div>
                      )}
                    </div>
                  );
                }
                if (task.taskStatusDetail.key === CONST.TS_APPROVED) {
                  return (
                    <div className="export-accept-block">
                      <div className="export-accept-common">
                        <button
                          onClick={() => this.showResume(item)}
                          className="btn btn-primary"
                          style={{ backgroundColor: '#32b16c' }}
                        >
                          履歴書を出力する
                        </button>
                      </div>
                      {taskEndDateTime > new Date() && (
                        <div className="export-accept-common">
                          <button
                            onClick={() => this.entryApprovalConfirm(item.taskrewId)}
                            className="btn btn-primary"
                            disabled={task.taskStatusDetail.key === CONST.TS_APPROVED}
                          >
                            応募を承認する
                          </button>
                        </div>
                      )}
                    </div>
                  );
                }
              })()}
            </td>
          </tr>
        );
      });
    }
    return (
      <tr>
        <td colSpan="6">請求対象となる実施済みのタスクがありません。</td>
      </tr>
    );
  };

  openApplicantModal = (user, task) => {
    this.setState({ openApplicantModal: true, user: user, task });
  };

  _renderTemplateData = item => {
    if (item != undefined) {
      return (
        <div>
          <div className="template_title">
            <label>承認時に送る注意事項</label>
          </div>
          <div className="template_titlevalue">
            <label>{item.templateName}</label>
          </div>
          <div
            className="textarea-border"
            dangerouslySetInnerHTML={{ __html: item.templateMessage }}
          />

          <div className="template_title">
            <label>持ち物</label>
          </div>
          <div className="belongings_div">
            {item.bringList.map(item => {
              return <li>{item} </li>;
            })}
          </div>
          <div className="template_title">
            <label>条件・注意事項</label>
          </div>
          <div className="belongings_div">
            {item.precautionList.map(item => {
              return <li>{item} </li>;
            })}
          </div>
        </div>
      );
    }
  };

  render = () => {
    const task = this.props.Task.taskDetail;
    const template = task.templateInfo;
    let approvedUsers = [];
    let activeUsers = [];
    let cancelUsers = [];
    let offerUsers = [];
    if (this.state.loaded) {
      if (Object.keys(task).length > 0) {
        approvedUsers = task.approvalTask === null ? [] : task.approvalTask.filter(Boolean);
        activeUsers = task.completedTask === null ? [] : task.completedTask.filter(Boolean);
        cancelUsers = task.cancelTask === null ? [] : task.cancelTask;
        offerUsers = task.offerTask === null ? [] : task.offerTask.filter(Boolean);
      }
      console.log('TCL: render -> cancelUsers', cancelUsers);
      // console.log(approvedUsers);
      console.log(task);
    }
    const activeTaskCount = approvedUsers.length;
    const allEntryCount = activeTaskCount;

    const isZeroParticipant = allEntryCount === 0;
    const canEdit = activeTaskCount === 0;
    const taskEndDateTime = new Date(`${task.endDate} ${task.endTime}`);
    var canDelete =
      task.taskStatusDetail &&
      task.taskStatusDetail.key === CONST.TS_APPROVED &&
      taskEndDateTime < new Date();
    let participantsView;
    if (isZeroParticipant) {
      participantsView = <p className="info-notice">このタスクにはまだ応募がありません。</p>;
    } else {
      participantsView = () => { };
    }
    console.log(
      'TCL: participantsView -> participantsView',
      this.state.loaded && this.state.currentTask
    );

    // console.log('Show', this.props, approvedUsers, activeUsers, cancelUsers, offerUsers)
    // console.log('allEntryCount:', allEntryCount)

    return (
      <Template>
        <Modal
          isOpen={this.state.modalOpen}
          closeModal={this.closeModalAction()}
          headerTitle={this.state.modalTitle}
          okClickHandler={null}
        >
          {this.modalContent(allEntryCount)}
        </Modal>
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle={this.props.App.modalHeader}
          okClickHandler={() => this.props.modalCloseInTask()}
          okText="閉じる"
          okBtnClass="btn btn-primary"
        >
          {this.props.App.modalText}
        </Modal>
        <ApplicantModal
          isOpen={this.state.openApplicantModal}
          closeModal={() => this.setState({ openApplicantModal: false })}
          headerTitle=""
          okClickHandler={null}
          user={this.state.user}
          task={this.state.task}
        />
        <div className="">
          <div className="task-detail-top">
            <h2 className="">タスク詳細</h2>
            {/*<h3 className="">{task.taskId}</h3>*/}
          </div>
          {(() => {
            if (this.state.loaded) {
              if (this.state.reviewPage === 'createReview') {
                return this._renderReview(task, allEntryCount);
              }
              if (this.state.reviewPage === 'reviewedView') {
                return this._renderOldReview(task, allEntryCount);
              }
              return (
                <div>
                  <TaskCardForDetail task={task} allEntryCount={allEntryCount} />
                  {this._renderTemplateData(template)}
                  <div className="task-detail-button">
                    {(() => {
                      if (this.state.loaded && this.state.currentTask) {
                        return (
                          // <Link to={RT.TASK_EDIT_PATH.replace(/:task_id/, task.taskId)} disabled={!canEdit} className='btn btn-primary btn-xs float-right ml-3'>このタスクを編集する</Link>
                          <button
                            onClick={() => {
                              this.props.history.push(
                                RT.TASK_DUPLICATE_PATH.replace(/:task_id/, task.taskId)
                              );
                            }}
                            // disabled={!canEdit}
                            className="btn btn-primary btn-xs"
                            style={{ backgroundColor: '#32b16c' }}
                          >
                            タスクの複製
                          </button>
                        );
                      }
                    })()}
                    {(() => {
                      if (this.state.loaded && this.state.currentTask) {
                        return (
                          // <Link to={RT.TASK_EDIT_PATH.replace(/:task_id/, task.taskId)} disabled={!canEdit} className='btn btn-primary btn-xs float-right ml-3'>このタスクを編集する</Link>
                          <button
                            onClick={() => {
                              this.props.history.push(
                                RT.TASK_EDIT_PATH.replace(/:task_id/, task.taskId)
                              );
                            }}
                            disabled={!canEdit}
                            className="btn btn-primary btn-xs"
                          >
                            このタスクを編集する
                          </button>
                        );
                      }
                    })()}
                    {(() => {
                      if (this.state.loaded && this.state.currentTask) {
                        return (
                          <button
                            onClick={this.deleteConfirm}
                            disabled={canDelete}
                            className="delete-task-button"
                          >
                            このタスクを削除する
                          </button>
                        );
                      }
                    })()}
                  </div>
                  {(() => {
                    if (isZeroParticipant) {
                      return participantsView;
                    }
                    return (
                      <div>
                        {(() => {
                          if (activeUsers.length > 0) {
                            let title = '確定したタスクルー';
                            if (!this.state.currentTask) {
                              title = '勤務したタスクルー';
                            }
                            return (
                              <div className="applicant-info">
                                <div className="title-panel">
                                  <h2>{title}</h2>
                                </div>
                                {(() => {
                                  return activeUsers.map(user => {
                                    if (user.participant != undefined) {
                                      const noBtn = !(
                                        task.taskStatusDetail.key === CONST.TS_APPROVED &&
                                        this.state.currentTask &&
                                        user.participant.key !== '7'
                                      );
                                      console.log('TCL: render -> noBtn', noBtn);

                                      return (
                                        <div className="applicant-info-inner">
                                          <ParticipantCard
                                            participant={user}
                                            enterpriseId={this.currentUser.enterpriseId}
                                            token={this.currentUser.accessToken}
                                            taskId={this.props.match.params.task_id}
                                            key={user.taskrewId}
                                            noBtn={noBtn}
                                          >
                                            {(() => {
                                              const taskEndDateTime = new Date(
                                                `${task.endDate} ${task.endTime}`
                                              );
                                              const canDoReview =
                                                user.participant.key === '2' &&
                                                task.taskStatusDetail.key === CONST.TS_APPROVED &&
                                                taskEndDateTime < new Date();
                                              if (
                                                task.taskStatusDetail.key === CONST.TS_APPROVED &&
                                                this.state.currentTask &&
                                                user.participant.key !== '7' &&
                                                !canDoReview
                                              ) {
                                                return (
                                                  <div className="button-inner ">
                                                    <div className="button-common">
                                                      <button
                                                        onClick={() => this.showContractPDF(user)}
                                                        className="btn btn-primary btn-xs"
                                                      >
                                                        契約書を出力する
                                                      </button>
                                                    </div>
                                                    <div className="button-common">
                                                      <button
                                                        onClick={() => this.showResume(user)}
                                                        className="btn btn-primary btn-xs"
                                                        style={{ backgroundColor: '#32b16c' }}
                                                      >
                                                        履歴書を出力する
                                                      </button>
                                                    </div>
                                                    {task.reviewCount == 0 && (
                                                      <div className="button-common">
                                                        <button
                                                          onClick={() =>
                                                            this.cancelApplyFromEnterpriseConfirm(
                                                              user.taskrewId
                                                            )
                                                          }
                                                          className="btn btn-primary btn-xs"
                                                          style={{ backgroundColor: '#898989' }}
                                                        >
                                                          承認取消
                                                        </button>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }
                                            })()}
                                            {(() => {
                                              // console.log('確定したタスクるー', user, user.participant.key === '6')
                                              const taskEndDateTime = new Date(
                                                `${task.endDate} ${task.endTime}`
                                              );
                                              console.log(
                                                'TCL: render -> taskEndDateTime',
                                                taskEndDateTime,
                                                taskEndDateTime < new Date(),
                                                new Date(),
                                                user.fastName
                                              );

                                              const canDoReview =
                                                user.participant.key === '2' &&
                                                task.taskStatusDetail.key === CONST.TS_APPROVED &&
                                                taskEndDateTime < new Date();
                                              const watchReview =
                                                (task.taskStatusDetail.key === CONST.TS_COMPLETE &&
                                                  user.participant.key === '3') ||
                                                task.reviewCount == 1;
                                              if (canDoReview) {
                                                return (
                                                  <div className="button-inner ">
                                                    <div className="button-common">
                                                      <button
                                                        onClick={() => this.showResume(user)}
                                                        className="btn btn-primary btn-xs"
                                                        style={{ backgroundColor: '#32b16c' }}
                                                      >
                                                        履歴書を出力する
                                                      </button>
                                                    </div>
                                                    <div className="button-common">
                                                      <button
                                                        onClick={() => this._toReview(user)}
                                                        className="btn btn-primary btn-xs"
                                                        style={{ backgroundColor: '#ffba00' }}
                                                      >
                                                        レビューをする
                                                      </button>
                                                    </div>
                                                  </div>
                                                );
                                              } else if (watchReview) {
                                                return (
                                                  <button
                                                    onClick={() => this._toViewReview(user)}
                                                    className="btn btn-primary btn-xs"
                                                    style={{
                                                      backgroundColor: '#ffba00'
                                                    }}
                                                  >
                                                    レビューを確認する
                                                  </button>
                                                );
                                              }
                                            })()}
                                          </ParticipantCard>
                                          {(() => {
                                            if (user.participant.key === '7') {
                                              return (
                                                <div className="cancel-confirm-wrap">
                                                  <h3>
                                                    このタスクルーからタスクのキャンセルリクエストが届きました。
                                                    <br />
                                                    キャンセルを確認してください。
                                                  </h3>
                                                  <div className="row">
                                                    <div className="col-9">
                                                      <p className="cancel-confirm-question">
                                                        このタスクルーのキャンセルに関して電話等で連絡はありましたか？
                                                      </p>
                                                    </div>
                                                    <div className="col-3">
                                                      <select
                                                        name="cancelMessageReceived"
                                                        className="form-select"
                                                        id=""
                                                        value={this.state.cancelMessageReceived}
                                                        onChange={this._setValue}
                                                      >
                                                        <option value="0">はい</option>
                                                        <option value="1">いいえ</option>
                                                      </select>
                                                      <button
                                                        onClick={() =>
                                                          this.cancelRequestAppry(user.taskrewId)
                                                        }
                                                        className="btn btn-primary mt-4"
                                                      >
                                                        キャンセルを確認する
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })()}
                                        </div>
                                      );
                                    }
                                  });
                                })()}
                              </div>
                            );
                          }
                        })()}
                        {(() => {
                          if (approvedUsers.length > 0) {
                            let title = '応募中のタスクルー';
                            if (!this.state.currentTask) {
                              title = '応募したタスクルー（未承認のタスクルー）';
                            }
                            return (
                              <div className="unapproved-task-block">
                                <h2>
                                  {title} {' | ' + '応募状況 ' + allEntryCount + '人'}
                                </h2>
                                <div className="table-responsive">
                                  <table className="table table-common">
                                    <thead>
                                      <tr>
                                        <th className="name">氏名</th>
                                        <th className="gender">性別</th>
                                        <th className="age">年齢</th>
                                        <th className="skill">保有資格</th>
                                        <th className="cancel">キャンセル回数</th>
                                        <th className="export-accept"></th>
                                      </tr>
                                    </thead>
                                    <tbody>{this._renderTaskItems(approvedUsers, task)}</tbody>
                                  </table>
                                </div>
                              </div>
                            );
                          }
                        })()}
                        {cancelUsers.bDatas !== undefined && cancelUsers.bDatas.length > 0 && (
                          <CancelUserList
                            cancelUsers={cancelUsers.bDatas}
                            title={
                              '[ キャンセルしたタスクルー | 施設側が承認取消ししたタスクルーリスト ]'
                            }
                            currentUser={this.currentUser}
                            task_id={this.props.match.params.task_id}
                          />
                        )}
                        {cancelUsers.cDatas !== undefined && cancelUsers.cDatas.length > 0 && (
                          <CancelUserList
                            cancelUsers={cancelUsers.cDatas}
                            title={' [ 応募取消済のタスクルー ]'}
                            currentUser={this.currentUser}
                            task_id={this.props.match.params.task_id}
                          />
                        )}
                        {(() => {
                          if (offerUsers.length > 0) {
                            return (
                              <div>
                                <h2>オファー済みのタスクルー</h2>
                                {(() => {
                                  return offerUsers.map(user => {
                                    return (
                                      <ParticipantCard
                                        participant={user}
                                        enterpriseId={this.currentUser.enterpriseId}
                                        token={this.currentUser.accessToken}
                                        taskId={this.props.match.params.task_id}
                                        key={user.taskrewId}
                                      />
                                    );
                                  });
                                })()}
                              </div>
                            );
                          }
                        })()}
                      </div>
                    );
                  })()}
                </div>
              );
            }
            return (
              <div>
                <p>読み込み中...</p>
              </div>
            );
          })()}
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
